import { render } from "./ExtendedCalendar.vue?vue&type=template&id=06b769a5"
import script from "./ExtendedCalendar.vue?vue&type=script&lang=js"
export * from "./ExtendedCalendar.vue?vue&type=script&lang=js"

import "./ExtendedCalendar.vue?vue&type=style&index=0&id=06b769a5&lang=scss"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__